import n, { useRef as e, useEffect as t, cloneElement as r } from "react";
function o(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
var u = {
    click: "onClick",
    focusin: "onFocus",
    focusout: "onFocus",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd"
  },
  c = function c(_c) {
    var i,
      a = _c.children,
      v = _c.onClickAway,
      s = _c.focusEvent,
      l = void 0 === s ? "focusin" : s,
      d = _c.mouseEvent,
      f = void 0 === d ? "click" : d,
      m = _c.touchEvent,
      E = void 0 === m ? "touchend" : m,
      p = e(null),
      h = e(null),
      L = e(!1);
    t(function () {
      return setTimeout(function () {
        L.current = !0;
      }, 0), function () {
        L.current = !1;
      };
    }, []);
    var w = function w(n) {
      return function (e) {
        h.current = e.target;
        var t = null == a ? void 0 : a.props[n];
        t && t(e);
      };
    };
    t(function () {
      var n,
        e,
        t = null !== (n = null === (e = p.current) || void 0 === e ? void 0 : e.ownerDocument) && void 0 !== n ? n : document,
        r = function r(n) {
          L.current && (p.current && p.current.contains(n.target) || h.current === n.target || !t.contains(n.target) || v(n));
        };
      return t.addEventListener(f, r), t.addEventListener(E, r), t.addEventListener(l, r), function () {
        t.removeEventListener(f, r), t.removeEventListener(E, r), t.removeEventListener(l, r);
      };
    }, [l, f, v, E]);
    var y = u[f],
      g = u[E],
      k = u[l];
    return n.Children.only(r(a, (o(i = {
      ref: function ref(n) {
        p.current = n;
        var e = a.ref;
        "function" == typeof e ? e(n) : e && (e.current = n);
      }
    }, k, w(k)), o(i, y, w(y)), o(i, g, w(g)), i)));
  };
c.displayName = "ClickAwayListener";
export { c as default };